<template>
    <div class="unlock-quota-free-container">
        <div class="unlock-quota-free" v-if="Type == 1">
            <div class="unlock-quota-free-Title">
                <TipsAndPrivewDilog :id="'SaleLead_Free_Tips'" :Title="$t('lbl_EMPBE_SalesLeadFreeQuota_P')">
                    <template v-slot:Text>
                        {{ $t('lbl_EMPBE_SalesLeadFreeQuota', { remainingCredit: YearRemainingQuota }) }}
                    </template>
                </TipsAndPrivewDilog>
            </div>
            <a
                :href="UpgradeUrl"
                target="_blank"
                :t_label="tLabel('UpgradePlan')"
            >{{ $t('lbl_EMPBE_SalesLeadFreeQuota_Defaultbutton') }}</a>
        </div>
        <!-- Type=2：仅未额度解锁时显示横幅；已用额度解锁不渲染「解锁成功」条，改由标题已读时间绿底标识 -->
        <div
            v-if="Type == 2 && quotaLoaded && IsLock"
            :class="pageBannerClass"
        >
            <!-- 需解锁但额度已用尽：Figma 4244:270318 升级横幅 -->
            <template v-if="isLockedNoQuota">
                <img
                    class="unlock-quota-free-Page-Icon"
                    :src="noQuotaLockImg"
                    alt=""
                />
                <div class="unlock-quota-free-Page-Content-noQuota">
                    <div class="unlock-quota-free-Page-Nav-Body unlock-quota-free-Page-Nav-Body-noQuota">
                        <div class="Title-noQuota">{{ noQuotaTitleText }}</div>
                        <div class="Desc-noQuota">{{ noQuotaDescText }}</div>
                    </div>
                    <div class="unlock-quota-free-Page-Actions">
                        <a
                            class="btn-learn"
                            :href="UpgradeUrl"
                            target="_blank"
                            rel="noopener"
                            :t_label="tLabel('LearnMore')"
                        >{{ $t('lbl_EMPBE_SalesLead_LearnMore') }}</a>
                        <a
                            href="javascript:void(0)"
                            class="btn-sales"
                            :t_label="tLabel('ContactSales')"
                            @click.prevent="onContactSales"
                        >{{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}</a>
                    </div>
                </div>
            </template>
            <!-- 有额度、仍锁定：Figma 4244:265409 浅蓝锁条 -->
            <template v-else>
                <div class="unlock-quota-free-Page-Nav">
                    <img
                        class="unlock-quota-free-Page-Icon"
                        :src="lockGraphicImg"
                        alt=""
                    />
                    <div class="unlock-quota-free-Page-Nav-Body">
                        <div class="Title-lock">
                            {{ lockTitleText }}
                        </div>
                        <div class="unlock-quota-free-Page-Meta">
                            <span class="unlock-quota-free-Page-Meta-booth">{{ currentEBoothText }}</span>
                            <SalesLeadQuotaDetails
                                variant="link"
                                :company-id="user && user.empCompanyId"
                                :show-upgrade="true"
                                @contact-sales="onContactSales"
                            />
                        </div>
                        <div v-if="mobile">
                            <a
                                class="lockButton"
                                @click="OpenDialog"
                                :t_label="tLabel('OpenUnlockDialog')"
                            >
                                <img :src="lockBtnImg" alt="" />
                                {{ unlockButtonText }}
                            </a>
                        </div>
                    </div>
                </div>
                <a
                    v-if="!mobile"
                    class="lockButton"
                    @click="OpenDialog"
                    :t_label="tLabel('OpenUnlockDialog')"
                >
                    <img :src="lockBtnImg" alt="" />
                    {{ unlockButtonText }}
                </a>
            </template>
        </div>
        <ConfettiExplosion ref="confetti"></ConfettiExplosion>
    </div>
</template>
<script>

import { InquiryFormService } from '../../../_services';
import { AlertDialog } from "@/_helpers/AlertDialog";
import SalesLeadQuotaDetails from './SalesLeadQuotaDetails.vue';

export default {
    mixins: [AlertDialog],
    components: { SalesLeadQuotaDetails },
    props: {
        Type: [String, Number],
        user: Object,
        rid: Number,
        mobile: Boolean,
        simulatedSupplier: Object,
        // Which sales lead type is being unlocked. Backend expects string.
        // Examples: 'Enquiry', 'NameCard'
        unlockType: {
            type: String,
            default: 'Enquiry'
        }
    },
    inject: {
        GetDetail: { default: null },
        permissionData: { default: null },
        openSalesLeadContactUs: { default: null },
    },
    data() {
        return {
            cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/Images/",
            IsLock: true,
            YearRemainingQuota: 0,
            EveryYearQuota: 0,
            quotaLoaded: false,
        }
    },
    computed: {
        langId() {
            return localStorage.getItem("currentLangId")
        },
        langCode() {
            return localStorage.getItem("currentLang")
        },
        /** 有额度锁定横幅左侧图（Figma Graphic v2：蓝锁 + ***） */
        lockGraphicImg() {
            const base = process.env.BASE_URL || '/';
            return `${base}img/epo-saleslead-unlock-graphic.svg`;
        },
        /** 解锁按钮内白色锁图标 */
        lockBtnImg() {
            const base = process.env.BASE_URL || '/';
            return `${base}img/epo-saleslead-unlock-btn-lock.svg`;
        },
        /** 无额度升级横幅左侧图（Figma Graphic v2 / Upgrade） */
        noQuotaLockImg() {
            const base = process.env.BASE_URL || '/';
            return `${base}img/epo-saleslead-upgrade-graphic.svg`;
        },
        DialogImg() {
            return `${this.cdnURL}SalesLead-lockQuota-new.png?x-oss-process=image/format,webp`;
        },
        /** 与采购墙「了解更多」一致：会员级别及权益页 */
        UpgradeUrl() {
            const lang = this.langCode || localStorage.getItem('currentLang') || 'simp';
            const base = (process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace/').replace(/\/?$/, '/');
            return `${base}MembershipsAndBenefits/${lang}`;
        },
        LockAndNonQuota() { // 当前是锁的状态并且还有额度
            return this.IsLock && this.YearRemainingQuota > 0;
        },
        /** 需解锁但额度已用尽 */
        isLockedNoQuota() {
            return this.IsLock && Number(this.YearRemainingQuota) <= 0;
        },
        pageBannerClass() {
            if (this.isLockedNoQuota) return 'unlock-quota-free-Page unlock-quota-free-Page-noQuota';
            return `unlock-quota-free-Page ${this.IsLock ? 'unlock-quota-free-Page-lock' : 'unlock-quota-free-Page-Unlock'}`;
        },
        noQuotaTitleText() {
            return this.$t('lbl_EMPBE_SalesLead_NoQuotaBanner_Title');
        },
        noQuotaDescText() {
            if (this.isNameCardUnlock) return this.$t('lbl_EMPBE_SalesLead_NoQuotaBanner_Desc_NameCard');
            if (this.isSourcingUnlock) return this.$t('lbl_EMPBE_SalesLead_NoQuotaBanner_Desc_Sourcing');
            if (this.isBookmarkUnlock) return this.$t('lbl_EMPBE_SalesLead_NoQuotaBanner_Desc_Bookmark');
            return this.$t('lbl_EMPBE_SalesLead_NoQuotaBanner_Desc_Enquiry');
        },
        isNameCardUnlock() {
            return String(this.unlockType || '').toLowerCase() === 'namecard';
        },
        isBookmarkUnlock() {
            return String(this.unlockType || '').toLowerCase() === 'bookmark';
        },
        isSourcingUnlock() {
            return String(this.unlockType || '').toLowerCase() === 'sourcingrequest';
        },
        BoothType() {
            const pd = this.permissionData?.value || this.permissionData;
            return pd?.Type || '';
        },
        boothPlanLabel() {
            if (this.BoothType === 'Guest') return this.$t('lbl_EMPBE_FreeEBooth');
            if (this.BoothType === 'Member') return this.$t('lbl_emp2_BasicEbooth');
            if (this.BoothType === 'A+') return this.$t('lbl_EMPBE_GradeAMore');
            if (this.BoothType === 'A') return this.$t('lbl_EMPBE_GradeA');
            if (this.BoothType === 'B') return this.$t('lbl_EMPBE_GradeB');
            if (this.BoothType === 'C') return this.$t('lbl_EMPBE_GradeC');
            return this.BoothType || '';
        },
        currentEBoothText() {
            return this.$t('lbl_EMPBE_SalesLead_CurrentEBooth', { grade: this.boothPlanLabel });
        },
        lockTitleText() {
            if (this.isNameCardUnlock) return this.$t('lbl_EMPBE_SalesLeadFreeQuota_Tips_NameCard');
            if (this.isSourcingUnlock) return this.$t('lbl_EMPBE_SalesLeadFreeQuota_Tips_Sourcing');
            if (this.isBookmarkUnlock) return this.$t('lbl_EMPBE_SalesLeadFreeQuota_Tips_Bookmark');
            return this.$t('lbl_EMPBE_SalesLeadFreeQuota_Tips');
        },
        unlockButtonText() {
            // 与名片等一致：横幅按钮统一「解锁」；点赞底部仍用「解锁以发送邀请」
            return this.$t('lbl_EMPBE_SalesLeadFreeQuota_UnlockBtn');
        },
        dialogTitleKey() {
            if (this.isNameCardUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Title_NameCard';
            // 有额度解锁：与询盘共用确认文案；额度用尽时仍用 Bookmark 升级弹窗
            if (this.isBookmarkUnlock && !this.LockAndNonQuota) {
                return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Title_Bookmark';
            }
            if (this.isBookmarkUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Title';
            return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Title';
        },
        dialogTipsKey() {
            if (this.isNameCardUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Tips_NameCard';
            if (this.isBookmarkUnlock && !this.LockAndNonQuota) {
                return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Tips_Bookmark';
            }
            if (this.isBookmarkUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Tips';
            return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Tips';
        },
        bookmarkQuotaText() {
            const text = this.$t('lbl_EMPBE_SalesLead_LikeFollow_FreeCreditsLeft');
            return String(text || '')
                .replace('{currentQuota}', this.YearRemainingQuota)
                .replace('{count}', this.YearRemainingQuota);
        },
        bookmarkSendInvitationText() {
            const text = this.$t('lbl_EMPBE_SalesLead_LikeFollow_SendInvitationWithQuota');
            const quota = `${this.YearRemainingQuota}/${this.EveryYearQuota}`;
            return String(text || '')
                .replace('{quota}', quota)
                .replace('{currentQuota}', this.YearRemainingQuota)
                .replace('{maxQuota}', this.EveryYearQuota);
        },
    },
    watch: {
        rid() {
            this.GetProductQuta();
        },
        unlockType() {
            // 当 unlockType 变化时（切换标签页），重新获取配额
            this.GetProductQuta();
        }
    },
    mounted() {
        this.GetProductQuta();
    },
    methods:
    {
        tLabel(eventName) {
            // Format: EMP3_SalesLead_类型_事件名称_id
            const type = this.unlockType || 'Enquiry';
            const id = this.rid || 0;
            return `EMP3_SalesLead_${type}_${eventName}_${id}`;
        },
        onContactSales() {
            if (typeof this.openSalesLeadContactUs === 'function') {
                this.openSalesLeadContactUs();
            }
        },
        GetProductQuta() {
            var that = this;
            that.quotaLoaded = false;
            InquiryFormService.GetUnlockQuotaFree({ companyId: that.user.empCompanyId, type: that.unlockType })
                .then((res) => {
                    if (res) {
                        that.YearRemainingQuota = res.yearUnlockQuota.yearRemainingQuota;
                        that.EveryYearQuota = res.yearUnlockQuota.everyYearQuota;
                        that.IsLock = !res.unlockQuotaList.includes(that.rid);
                        that.$emit('unlockQuota', that.IsLock && this.YearRemainingQuota==0);
                        that.$emit('unlockQuotaInfo', {
                            isLock: that.IsLock,
                            yearRemainingQuota: that.YearRemainingQuota,
                            everyYearQuota: that.EveryYearQuota
                        });
                    }
                })
                .finally(() => {
                    that.quotaLoaded = true;
                });
        },
        OpenDialog() {
            if(this.simulatedSupplier) return;
            var className = "AlertDialog-SalesLead-SaveSucess ";
            className += (this.LockAndNonQuota ? 'AlertDialog-popup-Salelead-Unlock' : 'AlertDialog-popup-Salelead-lock')
            this.showConfirm_Img(
                this.$t(this.dialogTitleKey),
                this.$t(this.dialogTipsKey,{remainingCredit:this.YearRemainingQuota, currentQuota: this.YearRemainingQuota}),
                this.$t('lbl_EMPBE_Confirm'),
                this.$t('lbl_EMPBE_Cancel'),
                this.$t('lbl_EMPBE_SalesLeadFreeQuota_Defaultbutton'),
                this.DialogImg,
                200,
                200,
                className,
                this.LockAndNonQuota,
                "EMPBE_Sale_Lead_UnlockConfirm",
                "EMPBE_Sale_Lead_UnlockCancel",
                "EMPBE_Sale_Lead_SalesLeadFreeQuota"
            ).then(res => {
                if (res.isDenied) {
                    window.open(this.UpgradeUrl, '_blank');
                } else if (res.isConfirmed && this.LockAndNonQuota) {
                    this.AddUnlockQuotaFree();
                    this.$refs.confetti.triggerConfetti();
                }
            });
        },
        AddUnlockQuotaFree() {
            var param = {
                EmpCompanyId: this.user.empCompanyId,
                UnlockType: this.unlockType,
                RelatedRID: this.rid,
                URL: window.location.href,
                BAgent: window.navigator.userAgent
            }
            InquiryFormService.AddUnlockQuotaFree(param).then(res => {
                if (res.isSuccessful) {
                    this.GetProductQuta();
                    //刷新最顶部层级
                    if (typeof this.GetDetail === 'function') {
                        this.GetDetail();
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.unlock-quota-free-container {
    width: 100%;
}

.unlock-quota-free-Page-Unlock {
    background: linear-gradient(90deg, #F1F0FF 0%, #F2F3F5 100%);
}

/* Figma 4244:265409 — Function/Info/Light */
.unlock-quota-free-Page-lock {
    background: #E7F8FF;
    border: 1px solid #B8DDF0;
    padding: 12px 16px;
    gap: 12px;

    /* Pic1 主文案 16px；Pic2 当前展台 14px */
    .Title-lock {
        font-size: 16px;
        line-height: 130%;
        font-weight: 700;
        color: rgba(0, 0, 0, 0.8);
    }

    .unlock-quota-free-Page-Meta-booth {
        font-size: 14px;
        line-height: 130%;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
    }
}

/* 额度用尽升级条 — 与总额度弹窗底部 `.sl-quota-popover__upgrade` 同色 */
.unlock-quota-free-Page-noQuota {
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    padding: 12px 16px;
    gap: 12px;
    container-type: inline-size;
    background: radial-gradient(
        ellipse 241.8% 251.52% at 102.83% 124.79%,
        #FFD631 0%,
        #FF7931 14%,
        #9554E2 45%,
        #8550FF 75%,
        #6231FF 100%
    );
}

.unlock-quota-free-Page {
    display: flex;
    padding: 16px 24px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    gap: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    min-width: 0;
    max-width: 100%;
    width: 100%;

    .unlock-quota-free-Page-Nav {
        display: flex;
        align-items: center;
        align-self: stretch;
        gap: 12px;
        min-width: 0;
        flex: 1 1 auto;
    }

    .unlock-quota-free-Page-Icon {
        width: 48px;
        height: 48px;
        flex-shrink: 0;
        object-fit: contain;
    }

    .unlock-quota-free-Page-Content-noQuota {
        display: flex;
        flex: 1 1 200px;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px 16px;
        min-width: 0;
        max-width: 100%;
    }

    .unlock-quota-free-Page-Nav-Body {
        display: flex;
        gap: 4px;
        flex-direction: column;
        min-width: 0;
    }

    .unlock-quota-free-Page-Nav-Body-noQuota {
        flex: 1 1 160px;
        min-width: 0;
        max-width: 100%;
        justify-content: center;
    }

    .Title-lock {
        color: rgba(0, 0, 0, 0.8);
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
    }

    .Title-Unlock {
        color: rgba(0, 0, 0, 0.8);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
    }

    .Title-noQuota {
        color: #fff;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
    }

    .Desc-noQuota {
        color: #fff;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
    }

    .unlock-quota-free-Page-Actions {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 8px;
        flex: 0 1 auto;
        min-width: 0;
        max-width: 100%;
    }

    .btn-learn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
        border-radius: 4px;
        color: #fff !important;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
        text-decoration: none !important;
        white-space: nowrap;
    }

    .btn-sales {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
        border-radius: 4px;
        background: #fff;
        color: #7366FF !important;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
        text-decoration: none !important;
        white-space: nowrap;
        cursor: pointer;
    }

    .unlock-quota-free-Page-Meta {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }

    .unlock-quota-free-Page-Meta-booth {
        color: rgba(0, 0, 0, 0.8);
        font-size: 14px;
        font-weight: 400;
        line-height: 130%;
    }

    .UnlockButton {
        white-space: nowrap;
        display: flex;
        padding: 8px 12px !important;
        align-items: center;
        border-radius: 4px;
        background: #7366FF;
        color: #FFF;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        letter-spacing: -0.154px;
        justify-content: center;
        flex-shrink: 0;
        transition: background-color 0.15s ease;

        &:hover {
            background: #5f52e6;
            color: #FFF;
            text-decoration: none;
        }

        &:active {
            background: #5548d9;
        }
    }

    .lockButton {
        white-space: nowrap;
        display: inline-flex;
        min-height: 36px;
        padding: 8px;
        justify-content: center;
        align-items: center;
        gap: 0;
        border-radius: 4px;
        border: none;
        cursor: pointer;
        background: #7366FF;
        color: #FFF !important;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 1;
        flex-shrink: 0;
        text-decoration: none !important;
        transition: background-color 0.15s ease;

        &:hover {
            background: #5f52e6;
            color: #FFF !important;
            text-decoration: none !important;
        }

        &:active {
            background: #5548d9;
        }

        img {
            width: 20px;
            height: 20px;
            display: block;
            margin-right: 4px;
        }
    }
}

.unlock-quota-free {
    display: flex;
    flex-wrap: wrap;
    padding: var(--8, 8px) var(--16, 16px);
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    gap: 8px;
    border-radius: var(--8, 8px);
    min-width: 0;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    background: radial-gradient(
        ellipse 241.8% 251.52% at 102.83% 124.79%,
        #FFD631 0%,
        #FF7931 14%,
        #9554E2 45%,
        #8550FF 75%,
        #6231FF 100%
    );

    .unlock-quota-free-Title {
        color: var(--On-Surface-White, #FFF);
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        flex: 1 1 160px;
        min-width: 0;
    }

    a {
        text-decoration: none;
        white-space: nowrap;
        display: flex;
        padding: var(--8, 8px) 12px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 4px;
        border: none;
        cursor: pointer;
        background: #FFF;
        color: #7366FF !important;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%;
        flex: 0 0 auto;
    }
}

/* 窄详情区：升级条文案与按钮上下排，避免挤扁 */
@container (max-width: 520px) {
    .unlock-quota-free-Page-Content-noQuota {
        flex-direction: column;
        align-items: stretch;
    }

    .unlock-quota-free-Page-Actions {
        width: 100%;
    }

    .unlock-quota-free-Page-lock,
    .unlock-quota-free-Page-Unlock {
        flex-wrap: wrap;
        align-items: flex-start;
    }

    .unlock-quota-free-Page-lock .lockButton,
    .unlock-quota-free-Page-Unlock .UnlockButton {
        width: 100%;
    }
}
</style>
